module.exports = __webpack_public_path__ + "static/media/spin.74671b0a.svg";